import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { app } from "./firebase.js";

const SITE_KEY = import.meta.env?.VITE_RECAPTCHA_SITE_KEY ?? "REPLACE_WITH_RECAPTCHA_ENTERPRISE_SITE_KEY";

export let appCheck = null;

const isLocal = typeof window !== "undefined" && 
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

if (!import.meta.env?.DEV && !isLocal) {
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}
